import { BulkImportType } from "components/server-types";
import {
  BookSectionIcon,
  GearSettingsIcon,
  PersonClassIcon,
  PersonCourseAdminIcon,
} from "mds/icons";

export const BULK_IMPORT_TYPES: BulkImportType[] = [
  "users",
  "course_admins",
  "sections",
  "enrollments",
];

export const CSV_TEMPLATES: Record<BulkImportType, readonly string[]> = {
  users: [
    "External User ID",
    "Given Name",
    "Family Name",
    "Email",
    "Institution Role",
    "isAccountActive",
    "Password",
    "Should Send Invite",
  ],
  course_admins: [
    "External User ID",
    "Given Name",
    "Family Name",
    "Email",
    "Add or Remove Course Admin Privileges",
    "Course or Folder?",
    "Course Code or Folder Title",
  ],
  sections: [
    "Term",
    "Course Code",
    "Section Type",
    "New Section Title",
    "External Section ID",
    "Template Section Title",
    "Default Section title to clone",
  ],
  enrollments: [
    "Term",
    "External Section ID",
    "External User ID",
    "Role",
    "Was Section Dropped", // CCM TODO: migrate to "Was Section Dropped"?
  ],
} as const;

export const SECTION_HEADERS_WITH_CONTEXT = {
  Term: "Term (Term in which you want the new section to be placed)",
  "Course Code": "Course Code (Code from the course where you want the new section to be placed.)",
  "Section Type": "Section Type (Select a Section Type - Default Section, or Linked Section.)",
  "New Section Title":
    "New Section Title (Section titles often decribe when the class runs and who is the main instructor.)",
  "External Section ID":
    "External Section ID (Optional field, only necessary when connected to an LMS.)",
  "Template Section Title":
    "Template Section Title (Mandatory field for creating sections linked to a Template.  If creating a Default Section, leave it blank.)",
  "Default Section title to clone":
    "Default Section title to clone (Optional field: fill if you wish to copy content from an existing Section to a new one. Leave it blank if you wish to create content in the new section from scratch.)",
} as const;

export const CCM_ONLY_SECTION_FIELDS = ["Section Type", "Template Section Title"];

export const IMPORT_TYPE_ICONS: Record<
  BulkImportType,
  React.ComponentType<{ className?: string }>
> = {
  users: PersonClassIcon,
  course_admins: PersonCourseAdminIcon,
  sections: BookSectionIcon,
  enrollments: GearSettingsIcon,
} as const;
